import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/site';

export default function HeroSection() {
  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20digital%20landscape%20with%20flowing%20data%20streams%2C%20dark%20atmosphere%20with%20warm%20coral%20red%20and%20amber%20gold%20gradient%20accents%2C%20modern%20tech%20noir%20aesthetic%2C%20wide%20cinematic%20composition%2C%20minimalist%20abstract%20background&width=1600&height=700&seq=hero-bg-main&orientation=landscape"
          alt="黑料聚合网"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-background-50" />
      </div>
      <div className="relative z-10 max-w-4xl mx-auto px-4 md:px-6 py-20 md:py-32 text-center">
        <div className="inline-flex items-center gap-2 bg-background-50/20 backdrop-blur-sm rounded-full px-4 py-1.5 mb-6">
          <span className="w-2 h-2 bg-accent-500 rounded-full animate-pulse"></span>
          <span className="text-sm text-background-50 font-medium">2026年8月 · 最新地址已更新</span>
        </div>
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 mb-4 leading-tight">
          {siteInfo.name}
        </h1>
        <p className="text-base md:text-lg text-background-50/80 mb-8 max-w-2xl mx-auto leading-relaxed">
          {siteInfo.tagline}，一站浏览51黑料最新、91黑料吃瓜、17黑料视频、718黑料合集等数字系列黑料内容
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/51heiliao"
            className="px-8 py-3 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-all duration-300 hover:scale-105 whitespace-nowrap"
          >
            浏览51黑料最新
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/category/chiigua"
            className="px-8 py-3 bg-background-50/20 backdrop-blur-sm text-background-50 rounded-full font-medium text-sm border border-background-50/30 hover:bg-background-50/30 transition-all duration-300 whitespace-nowrap"
          >
            开始吃瓜
            <i className="ri-emotion-line ml-2"></i>
          </Link>
        </div>
        <div className="flex flex-wrap items-center justify-center gap-6 mt-10">
          {[
            { label: '注册用户', value: siteInfo.stats.users, icon: 'ri-user-line' },
            { label: '日访问量', value: siteInfo.stats.dailyVisits, icon: 'ri-eye-line' },
            { label: '内容总数', value: siteInfo.stats.articles, icon: 'ri-article-line' },
          ].map((stat) => (
            <div key={stat.label} className="flex items-center gap-2">
              <span className="w-5 h-5 flex items-center justify-center text-background-50/60">
                <i className={stat.icon}></i>
              </span>
              <span className="text-background-50/80 text-sm">
                <strong className="text-background-50 font-semibold">{stat.value}</strong> {stat.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}